import axios from "axios";

// Use absolute URL so Axios does not treat it as a relative path to the
// frontend origin (which caused the 404 at http://localhost:3000/...).
const API = axios.create({
  baseURL: "https://api.ibis-sfax.com/api",
});

export default API;
